export default {
  name: 'Xybutton',
  props: {
    type: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean
    }
  },
  methods: {
    handleClick(evt) {
      if (this.disabled) return;
      this.$emit('click', evt);
    }
  }
};